<template>
    <page-section class="tab-section" :title="title" :actions="actions">
        <toggle v-if="tabs.length > 0" 
                :value="this.currentTabName" 
                :options="tabs" 
                valueKey="name"
                @input="clickTab($event)"/>

        <slot>
            <template v-if="currentTab">
                <slot :name="`tab-${currentTabName}`"/>
            </template>
        </slot>
    </page-section>
</template>

<style lang="scss">
    .tab-section--header-item {
        background: $dark-5;

        .btn {
            color: $toggle-color;

            &:hover {
                background: $toggle-bg-hover;
            }

            &.active {
                background: $toggle-bg-selected;
                color: $toggle-color-selected;
            }
        }
    }
</style>

<script>
    export default {
        props: {
            tabs: {type: Array, default: () => []},
            defaultTab: {type: String, default: null},
            title: {type: String, default: null},
            actions: {type: Array, default: () => []},
        },

        data() {
            return {
                currentTabName: this.defaultTab || (this.tabs.length > 0 ? this.tabs[0].name : null),
            };
        },

        computed: {
            currentTab() {
                return this.tabs.find(tab => tab.name === this.currentTabName);
            },
        },

        methods: {
            mergeTabDefaults(tab) {
                return {
                    theme: 'link-primary',
                    size: 'sm',
                    ...tab,
                };
            },

            mergeActionDefaults(action) {
                return {
                    theme: 'link',
                    size: 'sm',
                    ...action,
                };
            },

            clickTab(tab) {
                if (this.currentTabName != tab) {
                    this.currentTabName = tab;
                    this.$emit('tabChanged', {tabName:  tab, ...this.currentTab.payload});
                }
            },
        },
    };
</script>